import React from "react";
import { Button } from "../../Common/Button";
import { Icon as LucideIcon } from "../../Common/Icons/LucideIcons";
import { HeaderContainer, IconWrapper, Title } from "./__styles__/ChatHeader";

export interface ChatHeaderProps {
  onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose }) => {
  return (
    <HeaderContainer>
      <Title>
        <IconWrapper>
          <LucideIcon iconName="sparkles" color="contentPrimary" size={18} />
        </IconWrapper>
        Forerunner assistant
      </Title>
      <Button
        styleVariant="ghostGrey"
        size="small"
        leftIconName="x"
        onClick={onClose}
        aria-label="Close chat"
      />
    </HeaderContainer>
  );
};

export default ChatHeader;
